<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col>
      <b-overlay
        id="overlay-background"
        :show="notesbusy"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-card-header
            class="add-notes-header"
          >
            <b-card-title>{{ $t('DEBTIA_ADD_NOTES') }}</b-card-title>
            <b-card-title class="text-primary">
              <!-- <drag-links
                :parent="7"
                :side="side"
                :custom-change="customChange"
              /> -->
            </b-card-title>
          </b-card-header>
          <b-form>
            <validation-observer
              ref="addnotesform"
              tag="form"
            >
              <b-row>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    label-for="notes"
                    class="mb-1"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Notes"
                      rules="required"
                    >
                      <quill-editor
                        v-model="notestext"
                        :options="snowOption"
                        style="min-height: 150px"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col
                  sm="12"
                >
                  <b-form-group
                    :label="$t('DEBTIA_NOTE_VISIBLE_FOR')"
                    label-for="notes-roles"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Roles"
                      rules="required"
                    >
                      <v-select
                        id="notes-roles"
                        v-model="selectedRoles"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        multiple
                        label="label"
                        :options="noteRoles"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-button
                    class="notesSubmitBtn"
                    size="md"
                    variant="primary"
                    type="submit"
                    @click.prevent="notesfieldsfilled"
                  >
                    <span>{{ $t('DEBTIA_SUBMIT') }}</span>
                  </b-button>
                </b-col>
              </b-row>
            </validation-observer>
          </b-form>
          <b-alert
            v-if="showNotesAlert"
            variant="primary"
            class="notes-alert"
            show
          >
            <div class="alert-body">
              <span>{{ $t('DEBTIA_NOTE_ADDED_SUCCESS') }}</span>
            </div>
          </b-alert>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BForm, BFormGroup, BButton, BOverlay, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
// import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { quillEditor } from 'vue-quill-editor'
import vSelect from 'vue-select'
import { EventBus } from '@/event-bus'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import axios from '@axios'
// import { onMounted } from '@vue/composition-api'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BButton,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    vSelect,
    BForm,
    BFormGroup,
    BOverlay,
    // DragLinks,
    BCardHeader,
    BCardTitle,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      notesbusy: true,
      notestext: '',
      showNotesAlert: false,
      caseId: this.$route.params.id,
      snowOption: {
        theme: 'snow',
        modules: {
          toolbar: [],
        },
      },
      noteRoles: [],
      selectedRoles: [],
      selectedRoleNames: ['admin', 'company-super-admin', 'employee', 'afdelingsleder', 'legal', 'customer-support', 'finance'],
    }
  },
  computed: {
    invoicesTableFields() {
      return [
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_id', label: i18n.t('DEBTIA_PAYMENT_ID'), tdClass: 'text-right' },
        { key: 'sub_total', label: i18n.t('DEBTIA_SUB_TOTAL'), tdClass: 'text-right' },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'total_amount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
      ]
    },
  },
  // setup() {
  //   let selectedRoles = []
  //   const { invoicesData, noteRoles, caseId } = store.state['case-details']
  //   selectedRoles = noteRoles
  //   const snowOption = {
  //     theme: 'snow',
  //     modules: {
  //       toolbar: [],
  //     },
  //   }
  //   return {
  //     invoicesData,
  //     snowOption,
  //     noteRoles,
  //     selectedRoles,
  //     caseId,
  //   }
  // },
  created() {
  },
  methods: {
    async fetchInitialData() {
      await this.getNoteRoles()
    },
    getNoteRoles() {
      axios.get('/users/get-user-roles-dropdown').then(response => {
        if (response.status === 200) {
          this.noteRoles = response.data.data
          const roleMap = new Map(response.data.data.map(role => [role.name, role]))

          this.selectedRoles = this.selectedRoleNames
            .map(roleName => roleMap.get(roleName))
            .filter(role => role !== undefined)
          EventBus.$emit('setUserRoles', this.noteRoles)
          this.notesbusy = false
        }
      })
        .catch(error => console.log(error))
    },
    async notesfieldsfilled() {
      this.$refs.addnotesform.validate().then(async success => {
        if (success) {
          this.notesbusy = true
          const roles = []
          this.selectedRoles.forEach(x => roles.push(x.value))
          const obj = {
            debt_case_id: this.caseId,
            note: this.notestext,
            roles,
          }
          await axios.post(`${constants.baseUrlV2}/create-debt-case-logs`, obj).then(response => {
            if (response.status === 200) {
              this.notesbusy = false
              this.notestext = ''
              this.$refs.addnotesform.reset()
              EventBus.$emit('refreshLogs')
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
</style>
